import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApps = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(1 1)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14,32H5.016a5,5,0,0,1-5-5V5a5.01,5.01,0,0,1,5-5h22a5,5,0,0,1,5,5v9a1,1,0,0,1-2,0V5a3,3,0,0,0-3-3h-22a3.007,3.007,0,0,0-3,3V27a3,3,0,0,0,3,3H14a1,1,0,0,1,0,2Z",
				transform: "translate(-1.018 -1)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 9,
				height: 9,
				rx: 2,
				transform: "translate(8.482 2.136) rotate(45)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 9,
				height: 9,
				rx: 4.5,
				transform: "translate(16.982 4)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 9,
				height: 9,
				rx: 2,
				transform: "translate(3.982 17)",
				fill: "current"
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(2 40)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M400.075,652.419a1,1,0,0,1-.707-1.707l9.513-9.513a1,1,0,0,1,1.414,0l4.64,4.64a1,1,0,0,1-1.414,1.414l-3.933-3.933-8.806,8.806A1,1,0,0,1,400.075,652.419Z",
					transform: "translate(428.058 630.906) rotate(180)",
					fill: "current"
				})
			})
		]
	})
});
export { SvgApps as ReactComponent };
